import React from 'react';
import { useLocale } from '../../../../contexts/LocaleContext';
import { LINKS } from '../../../../config/links';
import './Hero.css';
import logo from '../../assets/images/logo.png';

const Hero: React.FC = () => {
  const { t } = useLocale();
  return (
    <section className="hero roamr-hero">
      <div className="container">
        <div className="hero-content">
          <div className="logo-container">
            <img 
              src={logo} 
              alt="AInstein Logo" 
              className="app-logo"
              width="200"
              height="60"
            />
          </div>
          <h2>{t('roamrHeading')}</h2>
          <p className="subtitle">
            {t('roamrDescription')}
          </p>
          <div className="cta-buttons">
            <a href={LINKS.apps.roamr.appStores.ios} className="download-btn ios" target="_blank" rel="noopener noreferrer" onClick={(e) => {
              if (LINKS.apps.roamr.appStores.ios === '#') {
                e.preventDefault();
                alert(t('roamrComingSoonIOS'));
              }
            }}>
              <i className="fab fa-apple"></i>
              <div>
                <span>{t('downloadOn')}</span>
                <span>{t('appStore')}</span>
              </div>
            </a>
            <a 
              href={LINKS.apps.roamr.appStores.android}
              className="download-btn android" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={(e) => {
                if (LINKS.apps.roamr.appStores.android === '#') {
                  e.preventDefault();
                  alert(t('roamrComingSoonAndroid'));
                }
              }}
            >
              <i className="fab fa-google-play"></i>
              <div>
                <span>{t('getItOn')}</span>
                <span>{t('googlePlay')}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
